module.exports = __webpack_public_path__ + "img/file-arrow-down-fill.9a52e724.svg";